import { Host, h } from "@stencil/core";
import { FallbackRenderInfo } from "../../utils/FallbackRenderInfo";
export class ApieFormMap {
    constructor() {
        this.subElements = undefined;
        this.name = undefined;
        this.label = null;
        this.value = undefined;
        this.types = '';
        this.renderInfo = new FallbackRenderInfo();
        this.enteredKey = '';
        this.touched = false;
    }
    onAddItemMap() {
        if (!this.value) {
            this.value = {};
        }
        this.value[this.enteredKey] = null;
        this.value = Object.assign({}, this.value);
        this.enteredKey = '';
        this.triggerChange.emit({
            name: this.name,
            value: this.value,
            force: true
        });
    }
    canNotAdd() {
        return this.enteredKey === ''
            || this.enteredKey === '__proto__'
            || (this.value && Object.hasOwnProperty.call(this.value, this.enteredKey));
    }
    removeFromList(node) {
        const nodeName = node.$attrs$.name;
        const keyName = nodeName.substring(this.name.length + 1, nodeName.length - 1);
        delete this.value[keyName];
        this.value = Object.assign({}, this.value);
        this.triggerChange.emit({
            name: this.name,
            value: this.value,
            force: true
        });
    }
    render() {
        const keyField = this.renderInfo.renderSingleInput(['map_key_field', 'text'], {
            name: '_internal' + this.name,
            label: 'Key',
            value: this.enteredKey,
            valueChanged: (newValue) => this.enteredKey = newValue !== null && newValue !== void 0 ? newValue : '',
            renderInfo: this.renderInfo,
            validationResult: {
                valid: true,
                messages: []
            },
            serverValidationError: {},
            touched: this.touched,
            onTouched: () => this.touched = true,
            currentFieldWrapper: this.renderInfo.createFieldWrapper(),
        });
        const addButton = this.renderInfo.renderAddItemToList({
            mappingKey: '__add' + this.enteredKey,
            disabled: this.canNotAdd(),
            isMap: true,
            label: 'Add',
            onRowAdd: () => this.onAddItemMap()
        });
        return (h(Host, { key: '225565b856c7d8a4f0032b982f808276416427fe' }, h("div", { key: '370ec4991e22a0c5e81b225763acaad93cfe47ba' }, this.subElements.filter((subElement) => {
            return !Array.isArray(subElement) || subElement.length > 0;
        }).map((subElement, index) => {
            return this.renderInfo.renderListOrMapRow({
                mappingKey: index,
                isMap: true,
                onRowRemove: () => this.removeFromList(subElement),
            }, subElement);
        })), this.renderInfo.renderAddItemToMap(keyField, addButton)));
    }
    static get is() { return "apie-form-map"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-map.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-map.css"]
        };
    }
    static get properties() {
        return {
            "subElements": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "VNode[]",
                    "resolved": "VNode[]",
                    "references": {
                        "VNode": {
                            "location": "import",
                            "path": "@stencil/core",
                            "id": "node_modules::VNode"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": true
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": true,
                "defaultValue": "null"
            },
            "value": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Record<string, any>",
                    "resolved": "{ [x: string]: any; }",
                    "references": {
                        "Record": {
                            "location": "global",
                            "id": "global::Record"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                }
            },
            "types": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "types",
                "reflect": true,
                "defaultValue": "''"
            },
            "renderInfo": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "RenderInfo",
                    "resolved": "RenderInfo",
                    "references": {
                        "RenderInfo": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::RenderInfo"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "new FallbackRenderInfo()"
            }
        };
    }
    static get states() {
        return {
            "enteredKey": {},
            "touched": {}
        };
    }
    static get events() {
        return [{
                "method": "triggerChange",
                "name": "triggerChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ChangeEvent",
                    "resolved": "ChangeEvent",
                    "references": {
                        "ChangeEvent": {
                            "location": "import",
                            "path": "../../utils/utils",
                            "id": "src/utils/utils.ts::ChangeEvent"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=apie-form-map.js.map
